export const OVERRIDE_ON_ERROR = {
  mutation: {
    onError: () => null,
  },
  query: {
    onError: () => null,
  },
};
